(function () {
  'use strict';
  var host = document.getElementById('mnl-config-loader');
  if (!host || window.mnlEnsureConfig) return;
  var status = document.getElementById('mnl-config-load-status');
  var message = document.getElementById('mnl-config-load-message');
  var retry = document.getElementById('mnl-config-load-retry');
  var resources = Object.create(null), work = null, ready = false, intent = null;
  var intentId = 0, fulfilledIntent = 0;
  var keys = ['mnlOpenConfig', 'mnlOpenStep', 'mnlApplyDoses', 'mnlApplyPreset', 'mnlLoadRecipe', 'mnlApplyObjective', 'mnlLoadObjectiveRecipe', 'mnlExpressOpen', 'mnlExpressLance'];
  var stubs = Object.create(null);
  function tell(state) {
    host.dataset.state = state;
    host.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
    if (status) status.hidden = state === 'ready' || state === 'idle';
    if (message) message.textContent = host.dataset[state === 'error' ? 'error' : 'loading'] || '';
    if (retry) { retry.hidden = state !== 'error'; retry.disabled = state === 'loading'; }
  }
  function requestAction(action) {
    var id = ++intentId;
    intent = { id: id, action: action };
    return ensure().then(function () { return fulfill(id); }).catch(function () { return false; });
  }
  function fulfill(id) {
    if (!intent || id !== intent.id || fulfilledIntent === id) return false;
    fulfilledIntent = id;
    return intent.action();
  }
  function resource(kind, url) {
    if (resources[url]) return resources[url];
    resources[url] = new Promise(function (resolve, reject) {
      var node = document.createElement(kind === 'css' ? 'link' : 'script');
      if (kind === 'css') { node.rel = 'stylesheet'; node.href = url; }
      else { node.src = url; node.async = false; }
      node.onload = function () { node.onload = node.onerror = null; resolve(); };
      node.onerror = function () {
        node.remove(); delete resources[url];
        reject(new Error('config_resource_unavailable'));
      };
      document.head.appendChild(node);
    });
    return resources[url];
  }
  function ensure() {
    if (ready) return Promise.resolve();
    if (!work) {
      work = resource('css', host.dataset.style).then(function () {
        if (!window.MNL_PRICES || !window.MNL_DOSE_THEME || !window.MNL_DOSES) throw new Error('config_dependencies_unavailable');
        window.mnlConfigDeferInit = true;
        return resource('js', host.dataset.engine);
      }).then(function () { return resource('js', host.dataset.guard); }).then(function () {
        if (!window.MNL_DOSE_GUARD || typeof window.mnlConfigInitialize !== 'function') throw new Error('config_guard_unavailable');
        window.dispatchEvent(new CustomEvent('mnl:config-engine-ready'));
        return window.mnlConfigInitialize();
      }).then(function () {
        if (!window.MNL_RECIPE_CATALOG || !window.MNL_RECIPE_CATALOG.isReady() || !window.MNL_DOSE_GUARD) throw new Error('config_not_initialized');
        ready = true;
        tell('ready');
        window.dispatchEvent(new CustomEvent('mnl:config-loaded'));
      }).catch(function (error) { work = null; throw error; });
    }
    tell('loading');
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { tell('error'); reject(new Error('config_load_timeout')); }, 20000);
      work.then(function () { clearTimeout(timer); tell('ready'); resolve(); }, function (error) {
        clearTimeout(timer); tell('error'); reject(error);
      });
    });
  }
  window.mnlEnsureConfig = ensure;
  keys.forEach(function (key) {
    if (typeof window[key] === 'function') return;
    var stub = function () {
      var args = Array.prototype.slice.call(arguments);
      var call = function () {
        if (window[key] === stub || typeof window[key] !== 'function') throw new Error('config_action_unavailable');
        return window[key].apply(window, args);
      };
      return requestAction(call);
    };
    stubs[key] = stub; window[key] = stub;
  });
  document.addEventListener('click', function (event) {
    if (ready || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
    var target = event.target.closest && event.target.closest('[data-mnl-recipe-entry], .mnl-cf__load, #mnl-cf-modify, [onclick*="mnlOpenConfig"], [onclick*="mnlExpress"]');
    if (!target) return;
    event.preventDefault(); event.stopImmediatePropagation();
    requestAction(function () { if (target.isConnected) target.click(); });
  }, true);
  if (retry) retry.addEventListener('click', function () {
    var id = intent && intent.id;
    ensure().then(function () { if (id) fulfill(id); }).catch(function () {});
  });
  var params = new URLSearchParams(location.search);
  if (['r', 'f', 'recette', 'recipe', 'preset', 'sport', 'step', 'express', 'abo'].some(function (key) { return params.has(key); }) || /^(config|formulas|picker)$/.test(params.get('open') || '')) {
    ensure().catch(function () {});
  } else tell('idle');
})();

